import React, { useEffect, useState } from "react";
import "./App.css";
import { motion } from "framer-motion";

function App() {
  const [vessels, setVessels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visits, setVisits] = useState(0);
  const [lastSynced, setLastSynced] = useState("");
  const [trackingLinks, setTrackingLinks] = useState({}); // store vessel_name → link

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await fetch(
        "https://fronxshipments.netlify.app/.netlify/functions/latest-ship"
      );
      const data = await res.json();
      setVessels(data);
      setLastSynced(new Date().toLocaleTimeString());

      // fetch tracking links too
      const linkRes = await fetch(
        "https://fronxshipments.netlify.app/.netlify/functions/tracking-links"
      );
      const linkData = await linkRes.json();

      // convert to object { vessel_name: tracking_link }
      const linkMap = {};
      linkData.forEach((item) => {
        linkMap[item.vessel_name.toLowerCase()] = item.tracking_link;
      });
      setTrackingLinks(linkMap);
    } catch (error) {
      console.error("Error fetching vessels:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Shipment Tracker - Suzuki Fronx Owners Club";
    fetchData();

    // Visitor Counter
    const storedVisits = localStorage.getItem("visitCount");
    const newCount = storedVisits ? parseInt(storedVisits) + 1 : 1;
    localStorage.setItem("visitCount", newCount);
    setVisits(newCount);
  }, []);

  return (
    <div className="app-container">
      {/* HEADER */}
      <header className="hero-section">
        <div className="hero-overlay">
          <motion.h1
            initial={{ y: -30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Shipment Tracker
          </motion.h1>
          <motion.h2
            initial={{ y: -20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            Suzuki Fronx Owners Club - Sri Lanka
          </motion.h2>
          <p className="last-synced">
            Last synced at: {lastSynced || "Fetching..."}
          </p>
          <motion.button
            className="refresh-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={fetchData}
          >
            🔄 Refresh Data
          </motion.button>
        </div>
      </header>

      {/* MAIN CONTENT */}
      {loading ? (
        <div className="loading-container">
          <div className="drone-animation" />
          <div className="loading-text">Fetching latest vessel information...</div>
        </div>
      ) : (
        <motion.div
          className="table-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <table>
            <thead>
              <tr>
                <th>ETA</th>
                <th>Vessel</th>
                <th>Last Port</th>
                <th>Berth</th>
                <th>Discharge</th>
                <th>Remarks</th>
                <th>Track</th> {/* NEW COLUMN */}
              </tr>
            </thead>
            <tbody>
              {vessels.map((v, idx) => {
                const link = trackingLinks[v.vessel_name?.toLowerCase()];
                return (
                  <motion.tr
                    key={idx}
                    className={
                      v.last_port?.toLowerCase() === "pipavav" ? "highlight" : ""
                    }
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ delay: idx * 0.05 }}
                  >
                    <td>{v.eta || "N/A"}</td>
                    <td>{v.vessel_name}</td>
                    <td>{v.last_port}</td>
                    <td>
                      {v.berth|| "N/A"}
                    </td>
                    <td>
                      {v.discharge && v.discharge !== "N/A" ? (
                        <span className="with-red-dot">{v.discharge}</span>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>{v.remarks || "N/A"}</td>
                    <td className="track-cell">
                      {link ? (
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="track-btn"
                        >
                         📍 Track
                        </a>
                      ) : (
                        <button className="track-btn disabled">🚫 Track</button>
                      )}
                    </td>
                  </motion.tr>
                );
              })}
            </tbody>
          </table>
        </motion.div>
      )}

      {/* FOOTER */}
      <footer className="footer">
        <div>All rights reserved by Fronx owners club Sri Lanka</div>
      </footer>
    </div>
  );
}

export default App;
